import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy-page">
      <Header />
      <div className="privacy-policy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: March 6, 2026</p>
        <p>Black Canyon Tickets respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect information obtained through our website and ticketing services.</p>

        <h2>1. Information We Collect</h2>
        <p>When you purchase tickets or use our services, we may collect the following information:</p>
        <p><strong>Personal Information</strong></p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Billing address</li>
        </ul>
        <p><strong>Payment Information</strong></p>
        <p>Payment information is processed through secure third-party payment processors. Black Canyon Tickets does not store full credit card numbers on its servers.</p>
        <p><strong>Technical Data</strong></p>
        <ul>
          <li>IP address</li>
          <li>Browser type</li>
          <li>Device information</li>
          <li>Pages visited</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Process ticket purchases</li>
          <li>Deliver tickets and event information</li>
          <li>Communicate event updates</li>
          <li>Improve our ticketing platform</li>
          <li>Prevent fraud and unauthorized transactions</li>
        </ul>

        <h2>3. Information Shared with Event Organizers</h2>
        <p>When you purchase a ticket, certain information may be shared with the event organizer, including:</p>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Ticket purchase details</li>
        </ul>
        <p>This allows organizers to manage attendance and communicate event updates.</p>

        <h2>4. Third-Party Services</h2>
        <p>Black Canyon Tickets may use third-party providers for:</p>
        <ul>
          <li>Payment processing</li>
          <li>Email communications</li>
          <li>Website analytics</li>
          <li>Fraud detection</li>
        </ul>
        <p>These providers only receive the information necessary to perform their services.</p>

        <h2>5. Cookies</h2>
        <p>Our website may use cookies to improve website functionality, track website usage, and remember user preferences. Users may disable cookies in their browser settings, though some website features may not function properly.</p>

        <h2>6. Data Security</h2>
        <p>We implement reasonable security measures to protect customer information. However, no internet transmission can be guaranteed to be completely secure.</p>

        <h2>7. Data Retention</h2>
        <p>We retain personal information only as long as necessary to fulfill ticket purchases, maintain business records, and comply with legal obligations.</p>

        <h2>8. Children's Privacy</h2>
        <p>Black Canyon Tickets services are not directed toward children under the age of 13, and we do not knowingly collect personal information from children.</p>

        <h2>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. Updates will be posted on our website with the revised date.</p>

        <h2>10. Contact Us</h2>
        <p>If you have questions about this Privacy Policy, contact:<br />
        Black Canyon Tickets<br />
        Email: <a href="mailto:support@blackcanyontickets.com">support@blackcanyontickets.com</a></p>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;